// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__up6ud","box":"styles_box__tpulR","flag":"styles_flag__Rov40"};